import { useIntl } from 'react-intl';
import {
  StyledAdminMobileFilterDrawer,
  StyledAdminMobileFilterDrawerFooter,
} from './style';
import { Icon } from 'ui';

interface AdminMobileFilterDrawerProps {
  isOpen: boolean;
  onClose: Function;
  children?: React.ReactNode;
  destroyOnClose?: boolean;
  zIndex?: number;
}

const AdminMobileFilterDrawer = ({
  isOpen,
  onClose,
  children,
  destroyOnClose = true,
  zIndex = 1100,
}: AdminMobileFilterDrawerProps) => {
  const intl = useIntl();

  const innerOnClose = () => {
    onClose();
  };

  return (
    <StyledAdminMobileFilterDrawer
      width={'100%'}
      open={isOpen}
      zIndex={zIndex}
      onClose={() => innerOnClose()}
      title={intl.formatMessage({ id: 'general.filter' })}
      closeIcon={<Icon name={'global-close-icon'} />}
      footer={
        <StyledAdminMobileFilterDrawerFooter></StyledAdminMobileFilterDrawerFooter>
      }
      destroyOnClose={destroyOnClose}
    >
      {children}
    </StyledAdminMobileFilterDrawer>
  );
};

export default AdminMobileFilterDrawer;
